module.exports = __webpack_public_path__ + "img/logo.081de0ae.png";